import React, { useState, useEffect, useRef } from 'react';
import { Button, Input, Table, Form, Spin, Select, Tabs, DatePicker, Checkbox, Popover, Radio } from 'antd';
import { CloseCircleOutlined, HomeOutlined, SearchOutlined, RedoOutlined, EyeOutlined, DownloadOutlined, InfoCircleOutlined } from '@ant-design/icons';
import Audit from '../../component/audit/audit';//審核彈框
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import { ContextHandler } from '../../public/js/contextHandler';
import context from '../../public/js/context';
import moment from 'moment';//日期格式化导包
import trans from './translation';
import Message from '../../component/message/message';
import tag1 from '../../public/img/tag/tag1.png';
import './wpaApplRecord.css'
import SelectCohortModule from './selectCohortModule';
import CohortProgSearchModal from './cohortProgSearchModal'

const { Option } = Select;
const { TabPane } = Tabs;
const { TextArea } = Input;

const WpaApplRecord = (props) => {

    const [form2] = Form.useForm();
    const messageRef = useRef();
    const [form] = Form.useForm();
    const [tabIndex, setTabIndex] = useState("1");
    const [flag, setFlag] = useState("add");
    const [isAudit, setIsAudit] = useState(false);
    const [tables, setTables] = useState([]);
    const [tablesQustion, setTablesQustion] = useState([]);
    const [tablesCount, setTablesCount] = useState(0);
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [searchModel, setSearchModel] = useState({});
    const [oldSearchModel, setOldSearchModel] = useState({});
    const [auditModel, setAuditModel] = useState({});
    const [isLoad, setIsLoad] = useState(false);
    const [spinInfo, setSpinInfo] = useState("");
    const [wpaApplModel, setWpaApplModel] = useState({});
    const [isSearchModuleModal, setIsSearchModuleModal] = useState(false);
    const [isSearchCohortProgModal, setIsSearchCohortProgModal] = useState(false);
    const [wpaQuestionModel, setWpaQuestionModel] = useState({});

    const tableColumns = {
        wpaApplId: "wpa_appl_id",
        firstName: "first_name",
        studentAcctId: "student_acct_id",
        companyName: "company_name",
        industrySupervisorName: "industry_supervisor_name",
        wilHours: "wil_hours",
        mark: "mark",
        applyDate: "apply_date",
        lastUpdatedDate: "last_updte_dte",
        sentToIs: "sent_to_is",
        wpaStatus: "wpa_status",
    }

    useEffect(() => {
        search(pageSize, 1, "N", false);
    }, []);

    const searchChange = (k, e) => {
        messageShowHandler();
        setSearchModel(newSearchModel => {
            return { ...newSearchModel, ...{ [k]: e } };
        })
    }

    //查询
    const search = (pageSizeNew, current, flag, isShowMsg, newModel) => {
        if (Config.funcInfo.canSelect === "N") {
            return;
        }
        messageShowHandler();
        let model = {};
        if ("Y" === flag) {//翻頁
            model = oldSearchModel;
        } else {
            if (newModel) {
                model = JSON.parse(JSON.stringify({ ...searchModel, ...newModel }));
            } else {
                model = JSON.parse(JSON.stringify(searchModel));
            }
        }
        model.pageSize = pageSizeNew;
        model.startRow = (current - 1) * pageSizeNew;
        model.page = current;
        model.progCodeList = Config.userInfo?.progCodeList
        model.cohortYear = Config.cohort?.cohortYear
        setIsLoad(true);
        setSpinInfo(trans.beQuerying[Config.backLang]);
        Base.callBackApi("wpaAppl/search", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                if (!data.object.list && isShowMsg) {
                    errFrameShow("info", trans.noneDate[Config.backLang]);
                }
                if ("N" === flag) {
                    setOldSearchModel(JSON.parse(JSON.stringify(model)));
                }
                setTablesCount(data?.object?.total ?? 0);
                setTables(data?.object?.list ?? []);
                setCurrent(current);
                setPageSize(pageSizeNew);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    //重置
    const reset = () => {
        messageShowHandler();
        setSearchModel({});
        form2.resetFields();
        setOldSearchModel({});
        setTablesCount(0);
        setTables([]);
        setPageSize(10);
    }

    // Tab页切换
    const handleSelect = (key) => {
        if (key) {
            if (key === "2") {
                if (Config.funcInfo.canInsert === "Y") {
                    add();
                }
            } else if (tabIndex !== "1") {
                setTabIndex("1");
                search(pageSize, current, "Y");
            }
        }
    }

    //添加
    const add = () => {
        messageShowHandler();//清空提示信息
        setWpaApplModel({})
        initForm({});
        setFlag("add");
        setTabIndex("2");
    }

    const initForm = (model = {}) => {
        form.resetFields();
        form.setFieldsValue({
            wpaApplId: model.wpaApplId ?? '',
            applyDate: (model.applyDate && moment(model.applyDate)) ?? null,
            studentAcctId: model.studentAcctId ?? '',
            firstName: model.firstName ?? '',
            lastName: model.lastName ?? '',
            studentName: (model.firstName ?? '') + ' ' + (model.lastName ?? ''),
            wpaStatus: model.wpaStatus ?? '',
            progTitle: model.progTitle ?? '',
            moduleName: model.moduleName ?? '',
            moduleCode: model.moduleCode ?? '',
            mark: model.mark ?? 'N/A',
            wilHours: model.wilHours ?? '',
            periodStartDate: (model.periodStartDate && moment(model.periodStartDate)) ?? null,
            periodEndDate: (model.periodEndDate && moment(model.periodEndDate)) ?? null,
            companyName: model.companyName ?? '',
            companyAddress: model.companyAddress ?? '',
            industrySupervisorName: model.industrySupervisorName ?? '',
            industrySupervisorPosition: model.industrySupervisorPosition ?? '',
            industrySupervisorPhone: model.industrySupervisorPhone ?? '',
            industrySupervisorEmail: model.industrySupervisorEmail ?? '',
            wilHoursIs: model.wilHoursIs ?? '',
            periodStartDateIs: (model.periodStartDateIs && moment(model.periodStartDateIs)) ?? null,
            periodEndDateIs: (model.periodEndDateIs && moment(model.periodEndDateIs)) ?? null,
            companyNameIs: model.companyNameIs ?? '',
            companyAddressIs: model.companyAddressIs ?? '',
            industrySupervisorNameIs: model.industrySupervisorNameIs ?? '',
            industrySupervisorPositionIs: model.industrySupervisorPositionIs ?? '',
            industrySupervisorPhoneIs: model.industrySupervisorPhoneIs ?? '',
            industrySupervisorEmailIs: model.industrySupervisorEmailIs ?? '',
            activity1: model.activity1 ?? '',
            activity2: model.activity2 ?? '',
            activity3: model.activity3 ?? '',
            activityProportion1: model.activityProportion1 ?? '',
            activityProportion2: model.activityProportion2 ?? '',
            activityProportion3: model.activityProportion3 ?? '',
            wpaQuestionResult1: model?.wpaQuestionResult1 ?? '',
            wpaQuestionResult2: model?.wpaQuestionResult2 ?? '',
            wpaQuestionResult3: model?.wpaQuestionResult3 ?? '',
            wpaQuestionResult4: model?.wpaQuestionResult4 ?? '',
            wpaQuestionResult5: model?.wpaQuestionResult5 ?? '',
            wpaQuestionResult6: model?.wpaQuestionResult6 ?? '',
            wpaQuestionResult7: model?.wpaQuestionResult7 ?? '',
            wpaQuestionResult8: model?.wpaQuestionResult8 ?? '',
            wpaQuestionResult9: model?.wpaQuestionResult9 ?? '',
            wpaQuestionResult10: model?.wpaQuestionResult10 ?? '',
            wpaQuestionResult11: model?.wpaQuestionResult11 ?? '',
            wpaQuestionResult12: model?.wpaQuestionResult12 ?? '',
            wpaQuestionResult13: model?.wpaQuestionResult13 ?? '',
            workPerformance: model?.workPerformance ?? '',
            strengthArea: model?.strengthArea ?? '',
            growthArea: model?.growthArea ?? '',
            workPerformanceComment: model?.workPerformanceComment ?? '',
            signature: model?.signature ?? '',
            signatureDate: model?.signatureDate ? moment(model?.signatureDate) : null,
            remarks: model.remarks ?? '',
            comments: model.comments ?? '',
        });
    }

    const audit = (model, e) => {
        messageShowHandler();//清空提示信息
        e.stopPropagation();
        setAuditModel(model);
        setIsAudit(true);
    }

    // 审核弹窗
    const auditCancel = () => {
        setIsAudit(false);
    }

    const onSave = (model) => {
        messageShowHandler();//清空提示信息
        setIsLoad(true);
        setSpinInfo(trans.dataBeSaving[Config.backLang])
        
    }

    //取消 
    const cancel = () => {
        messageShowHandler();
        setTabIndex("1");
        search(pageSize, current, "Y");
    }

    //分页 页码切换变化查询
    const onChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, currentNew, "Y");
    }

    //分页 每页條數变化查询
    const onShowSizeChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, 1, "Y");
    }

    /** 生成提示信息 */
    const errFrameShow = (style, msg) => {
        messageRef.current.setStyle(style)
        messageRef.current.setContent(msg)
        messageRef.current.setIsShow(true)
        document.documentElement.scrollTop = 0;
    }

    /** 清空提示信息 */
    const messageShowHandler = () => {
        messageRef.current.setIsShow(false)
    }

    const update = (model, e) => {
        e.stopPropagation();
        searchById(model)
        setTabIndex("2");
    }

    const searchById = (model) => {
        setIsLoad(true);
        setSpinInfo(trans.beQuerying[Config.backLang]);
        searchWpaQuestion(model);
        Base.callBackApi("wpaAppl/searchById", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                let model = data.object ?? {};
                setFlag("edit");
                initForm(model)
                setWpaApplModel(model);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const searchWpaQuestion = (model) => {
        Base.callBackApi("wpaAppl/searchWpaQuestion", model).then((data) => {
            if ("SUCCESS" === data?.msg) {
                let model = data.object ?? {};
                setWpaQuestionModel(model);
                let list = [];
                for(let i = 1; i <= 8; i++) {
                    if(model['wpaQuestion' + i]) {
                        list.push({
                            id: 'wpaQuestionResult' + i,
                            question: model['wpaQuestion' + i],
                        })
                    }
                }
                for(let i = 9; i <= 13; i++) {
                    if(model['programmeSpecificWpaQuestion' + i]) {
                        list.push({
                            id: 'wpaQuestionResult' + i,
                            question: model['programmeSpecificWpaQuestion' + i],
                        })
                    }
                }
                setTablesQustion(list);
            } else {
                errFrameShow("error", data.msg);
            }
        })
    }

    const handleTableChange = (pagination, filters, sorter) => {    
        let orderBy = "";
        if (sorter.field) {
            if (sorter.order === "ascend") {
                orderBy = tableColumns[sorter.field];
            } else if (sorter.order === "descend") {
                orderBy = tableColumns[sorter.field] + " DESC";
            }
        }
        if (!!sorter.field || !!searchModel.orderBy) {
            if (orderBy !== searchModel.orderBy) {
                searchModel.orderBy = orderBy;
                search(pageSize, 1, "N", true);
            }
        }
    }

    const onSearch = () => {
        search(pageSize, 1, "N")
    }

    const downloadFile = (item) => {
        if (!Base.stopClick()){
            return;
        }
        Base.downloadFile(Config.wpaAppl + item.filePath + '?' + Config.sasToken, item.fileName)
    }

    const generatePdf = () => {
        if (isLoad) {
            return;
        }
        setIsLoad(true);
        let model = wpaApplModel;
        fetch(Config.apiDownloadServer + "adminWPAFormPdf/generatePdf", {
            method: 'POST',
            body: JSON.stringify(model),
            headers: Config.header,
            mode: 'cors',
            cache: 'default'
        }).then(res => res.blob()).then(blob => {
            if (blob.type == "application/json") {
                var reader = new FileReader();
                reader.onload = e => {
                    var data = JSON.parse(e.target.result);
                    console.log(data);
                    // errFrameShow("error", data.msg);
                }
                reader.readAsText(blob);
            } else {
                var filename = "WPAForm" + moment(new Date()).format(Config.dateFormat3) + Base.generateFourDigitRandomNumber() + ".pdf";
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {// for IE
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else {// for Non-IE (chrome, firefox etc.)
                    var a = document.createElement('a');
                    document.body.appendChild(a);
                    a.style = 'display: none';
                    var url = window.URL.createObjectURL(blob);
                    a.href = url;
                    a.download = filename;
                    a.click();
                    a.remove();
                    window.URL.revokeObjectURL(url);
                }
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }
    
    const selectCohortModuleClose = (flag, model) => {
        if (flag) {
            setSearchModel(model1 => {
                return { ...model1, ...model };
            });
        }
        setIsSearchModuleModal(false);
    }

    const closeSearchCohortProgModal = (flag, cohortProg) => {
        if (flag) {
            setSearchModel(model1 => {
                return { ...model1, ...cohortProg };
            });
        }
        setIsSearchCohortProgModal(false);
    }

    /*eslint-disable*/
    const columns = [
        {
            title: 'WPA ID',
            dataIndex: 'wpaApplId',
            width: '5%',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'wpaApplId') },
        },
        {
            title: 'Student ID',
            dataIndex: 'studentAcctId',
            width: '8%',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'studentAcctId') },
        },
        {
            title: 'Student Name',
            dataIndex: 'firstName',
            width: '8%',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'firstName') },
            render: (text, record) => record.firstName + ' ' + record.lastName
        },
        {
            title: "Programme Name",
            dataIndex: 'progTitle',
            width: '9%',
        },
        {
            title: "Module Code",
            dataIndex: 'moduleCode',
            width: '8%',
        },
        {
            title: "Module Name",
            dataIndex: 'moduleName',
            width: '8%',
        },
        {
            title: 'Company',
            dataIndex: 'companyName',
            width: '8%',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'companyName') },
            render: text => (
                <Popover content={text} title="" trigger="hover">
                    <div className='tableEllipsisBox'>{text}</div>
                </Popover>
            ),
        },
        {
            title: 'Industry Supervisor',
            dataIndex: 'industrySupervisorName',
            width: '10%',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'industrySupervisorName') },
            render: text => (
                <Popover content={text} title="" trigger="hover">
                    <div className='tableEllipsisBox'>{text}</div>
                </Popover>
            ),
        },
        {
            title: 'WIL Hours',
            dataIndex: 'wilHours',
            width: '7%',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'wilHours') },
            render: (text) => Base.parseToFixed(text, 1),
        },
        {
            title: 'Mark',
            dataIndex: 'mark',
            width: '5%',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'mark') },
            render: (text) => Base.parseToFixed(text, 1),
        },
        {
            title: 'Submit Date',
            dataIndex: 'applyDate',
            width: '8%',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'applyDate') },
            render: text => text ? moment(text).format(Config.dateFormatEn) : '',
        },
        {
            title: 'Last Update',
            dataIndex: 'lastUpdatedDate',
            width: '8%',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'lastUpdatedDate') },
            render: text => text ? moment(text).format(Config.dateFormatEn) : '',
        },
        {
            title: 'Sent to IS over 14 days',
            dataIndex: 'sentToIs',
            width: '8%',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'sentToIs') },
        },
        {
            title: 'Status',
            dataIndex: 'wpaStatus',
            width: 180,
            sorter: (a, b) => { return Base.sortMethod(a, b, 'wpaStatus') },
            render: text => ContextHandler.getMapValue('wpaFormStatusMap', text),
        },
        {
            title: trans.controls[Config.backLang],
            dataIndex: '',
            fixed: 'right',
            className: ' sysControls',
            width: 90,
            render: (text, record) => <div className='operation'>
                <div className='sysUpdate' onClick={(e) => update(record, e)} hidden={Config.funcInfo.canView === "N"}><EyeOutlined /> {trans.detail[Config.backLang]}</div>
            </div>
        },
    ];

    const columnsQustion = [
        {
            title: '',
            dataIndex: 'question',
        },
        {
            title: '\xa05\xa0\xa0\xa0\xa0\xa04 \xa0\xa0\xa03\xa0\xa0\xa0\xa0\xa02\xa0\xa0\xa0\xa01\xa0\xa0\xa0\xa0 0',
            dataIndex: 'id',
            width: 200,
            render: text => (
                <Form.Item
                    name={text}
                    rules={[
                        { required: true, message: "This is required." },
                    ]}
                >
                    <Radio.Group name="radiogroup" className='radioBox' disabled>
                        <Radio value={5}></Radio>
                        <Radio value={4}></Radio>
                        <Radio value={3}></Radio>
                        <Radio value={2}></Radio>
                        <Radio value={1}></Radio>
                        <Radio value={0}></Radio>
                    </Radio.Group>
                </Form.Item>
            ),
        },
    ];
    /*eslint-enable*/

    return (
        <div id="container" className="template wpaApplRecord">
            <div className='breadcrumb'>
                <HomeOutlined /> / {trans.admin[Config.backLang]} / <span className='breadcrumbTitle'>{Config.funcInfo['funcName' + (Config.backLang === 'TC' ? 'Tc' : (Config.backLang === 'EN' ? 'En' : ''))]}</span>
            </div>
            {/* 提示信息弹框 */}
            <Message ref={messageRef} />
            <div className='templateMain'>
                <Spin spinning={isLoad} size="large" tip={spinInfo}>
                    {/* 审核彈框 */}
                    <Audit visible={isAudit} auditModel={auditModel} close={auditCancel} />
                    <Tabs activeKey={tabIndex} onChange={(e) => handleSelect(e)}>
                        <TabPane key="1" tab={trans.list[Config.backLang]}>
                            <Form form={form2} onFinish={onSearch}>
                                <div className='sysSearchRow sysSearchBox'>
                                    <div className='sysRow'>
                                        <div className='sysCol'>
                                            <div className="sysTitle">{trans.studentAcctId[Config.backLang]}</div>
                                            <div className="sysSerchInput">
                                                <Input type="text" value={searchModel.studentAcctId || ''}
                                                    placeholder={trans.studentAcctId[Config.backLang]}
                                                    onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                                    onChange={(e) => searchChange('studentAcctId', e.target.value)}
                                                    onInput={(e) => {
                                                        e.target.value = e.target.value.replace(/[^A-Za-z0-9]/g, ''); // 只允许输入字母和数字
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className='sysCol'>
                                            <div className="sysTitle">{trans.studentName[Config.backLang]}</div>
                                            <div className="sysSerchInput">
                                                <Input type="text" value={searchModel.firstName || ''}
                                                    placeholder={trans.studentName[Config.backLang]}
                                                    onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                                    onChange={(e) => searchChange('firstName', e.target.value)} />
                                            </div>
                                        </div>
                                        <div className='sysCol'>
                                            <div className="sysTitle">{trans.wpaStatus[Config.backLang]}</div>
                                            <div className="sysSerchInput">
                                                <Select className="sysSelect" placeholder={trans.wpaStatus[Config.backLang]}
                                                    value={searchModel.wpaStatus || ''}
                                                    onChange={(e) => searchChange('wpaStatus', e)}
                                                >
                                                    <Option value=""></Option>
                                                    {context.wpaFormStatusMap.map((item) => <Option key={item.value} value={item.value}>{item.label}</Option>)}
                                                </Select>
                                            </div>
                                        </div>
                                        <div className='sysCol'>
                                            <div className="sysTitle">Programme </div>
                                            <div className="sysButtonSearchInput">
                                                <Input type="text" value={searchModel.progCode || ''} disabled
                                                    placeholder="Programme "
                                                    onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                                    onChange={(e) => searchChange('progCode', e.target.value)} />
                                            </div>
                                            <Button className="sysBtn btnBlue" onClick={() => { setIsSearchCohortProgModal(true) }}>Select</Button>
                                            {searchModel.progTitle && <div style={{ marginLeft: '10px' }}>{searchModel.progTitle}</div>}
                                        </div>
                                        <div className='sysCol'>
                                            <div className="sysTitle">Module</div>
                                            <div className="sysButtonSearchInput">
                                                <Input type="text" value={searchModel.moduleCode || ''} disabled
                                                    placeholder="Module"
                                                    onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                                    onChange={(e) => searchChange('moduleCode', e.target.value)} />
                                            </div>
                                            <Button className="sysBtn btnBlue" onClick={() => { setIsSearchModuleModal(true) }}>Select</Button>
                                            {searchModel.moduleName && <div style={{ marginLeft: '10px' }}>{searchModel.moduleName}</div>}
                                        </div>
                                        <div className='sysSearchButton'>
                                            <Button className="sysBtn btnBlue" type="primary" onClick={() => form2.submit()} hidden={Config.funcInfo.canSelect === "N"} icon={<SearchOutlined />}>{trans.search[Config.backLang]}</Button>
                                            <Button className="sysBtn" onClick={reset} icon={<RedoOutlined />}>{trans.reset[Config.backLang]}</Button>
                                        </div>
                                    </div>
                                </div>
                            </Form>
                            <div className="sysLineEight"></div>
                            <div className="sysTable" id="tableOne">
                                <Table
                                    scroll={{ x: 2000 }}
                                    rowKey="wpaApplId"
                                    columns={columns} //列名
                                    dataSource={tables} //数据
                                    pagination={{  //分页
                                        showSizeChanger: true,                          //是否显示可以设置几条一页的选项
                                        onChange: onChange,            //上页下页或者跳页方法
                                        onShowSizeChange: onShowSizeChange,    //每页显示多少条数据方法
                                        total: tablesCount,             //总共多少条数据
                                        current: current,         //当前页
                                        pageSize: pageSize,       //每页显示多少条数据
                                        defaultCurrent: 1,                               //默认当前页为1
                                        size: "small"
                                    }}
                                    onChange={handleTableChange}
                                />
                            </div>
                        </TabPane>
                        <TabPane key="2" tab={Config.funcInfo['funcName' + (Config.backLang === 'TC' ? 'Tc' : (Config.backLang === 'EN' ? 'En' : ''))]} forceRender={true}>
                            <Form
                                form={form} onFinish={onSave}
                            >
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam ">WPA ID</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="wpaApplId"
                                            >
                                                <Input type="text" placeholder='WPA ID' disabled />
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam ">Submit Date</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="applyDate"
                                            >
                                                <DatePicker placeholder='Submit Date'
                                                        className="parts-numberInput datePickerAllWidth"
                                                        format={Config.dateFormatEn} disabled />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam ">Mark</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="mark"
                                            >
                                                <Input type="text" placeholder='Mark' disabled />
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam ">Status</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="wpaStatus"
                                            >
                                                <Select disabled>
                                                    <Option value=""></Option>
                                                    {context.wpaFormStatusMap.map(item => <Option key={item.value} value={item.value}>{item.label}</Option>)}
                                                </Select>
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam ">{trans.studentName[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="studentName"
                                            >
                                                <Input type="text" placeholder={trans.studentName[Config.backLang]} disabled />
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam ">{trans.studentAcctId[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="studentAcctId"
                                            >
                                                <Input type="text" placeholder={trans.studentAcctId[Config.backLang]} disabled />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam ">Programme Title</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="progTitle"
                                            >
                                                <Input type="text" placeholder='Programme Title' disabled />
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam ">WIL Module Code</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="moduleCode"
                                            >
                                                <Input type="text" placeholder='WIL Module Code' disabled />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam ">WIL Module Title</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="moduleName"
                                            >
                                                <Input type="text" placeholder='WIL Module Title' disabled />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className={'checkStudentOrISBox ' + (wpaApplModel?.selectStudentOrIs === "STUDENT" && "checkedStudentOrISBox")}>
                                    <div className='checkStudentOrISFlex'>
                                        <div className='title'>
                                            Profile information input by Student
                                        </div>
                                        <Checkbox value="IS" checked={wpaApplModel?.selectStudentOrIs === "STUDENT"} disabled></Checkbox>
                                    </div>
                                    <div className='sysRow'>
                                        <div className='sysCol'>
                                            <div className="sysParam ">Total WIL Hours</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="wilHours"
                                                >
                                                    <Input type="text" placeholder='WIL Module Code' disabled />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='sysRow'>
                                        <div className='sysCol'>
                                            <div className="sysParam ">WIL Period Start</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="periodStartDate"
                                                >
                                                    <DatePicker placeholder='WIL Period Start'
                                                            className="parts-numberInput datePickerAllWidth"
                                                            format={Config.dateFormatEn} disabled />
                                                </Form.Item>
                                            </div>
                                        </div>
                                        <div className='sysCol'>
                                            <div className="sysParam ">WIL Period End</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="periodEndDate"
                                                >
                                                    <DatePicker placeholder='WIL Period End'
                                                            className="parts-numberInput datePickerAllWidth"
                                                            format={Config.dateFormatEn} disabled />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='sysRow'>
                                        <div className='sysCol'>
                                            <div className="sysParam ">Company/ Organisation Name</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="companyName"
                                                >
                                                    <Input type="text" placeholder='Company/ Organisation Name' disabled />
                                                </Form.Item>
                                            </div>
                                        </div>
                                        <div className='sysCol'>
                                            <div className="sysParam ">Company/ Organisation Address</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="companyAddress"
                                                >
                                                    <Input type="text" placeholder='Company/ Organisation Address' disabled />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='sysRow'>
                                        <div className='sysCol'>
                                            <div className="sysParam ">Name</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="industrySupervisorName"
                                                >
                                                    <Input type="text" placeholder='Name' disabled />
                                                </Form.Item>
                                            </div>
                                        </div>
                                        <div className='sysCol'>
                                            <div className="sysParam ">Position</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="industrySupervisorPosition"
                                                >
                                                    <Input type="text" placeholder='Position' disabled />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='sysRow'>
                                        <div className='sysCol'>
                                            <div className="sysParam ">Telephone Number</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="industrySupervisorPhone"
                                                >
                                                    <Input type="text" placeholder='Telephone Number' disabled />
                                                </Form.Item>
                                            </div>
                                        </div>
                                        <div className='sysCol'>
                                            <div className="sysParam ">Email Address</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="industrySupervisorEmail"
                                                >
                                                    <Input type="text" placeholder='Email Address' disabled />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className={'checkStudentOrISBox ' + (wpaApplModel?.selectStudentOrIs === "IS" && "checkedStudentOrISBox")}>
                                    <div className='checkStudentOrISFlex'>
                                        <div className='title'>
                                            Profile information input by Industry Supervisor
                                        </div>
                                        <Checkbox value="IS" checked={wpaApplModel?.selectStudentOrIs === "IS"} disabled></Checkbox>
                                    </div>
                                    <div className='sysRow'>
                                        <div className='sysCol'>
                                            <div className="sysParam ">Total WIL Hours</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="wilHoursIs"
                                                >
                                                    <Input type="text" placeholder='WIL Module Code' disabled />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='sysRow'>
                                        <div className='sysCol'>
                                            <div className="sysParam ">WIL Period Start</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="periodStartDateIs"
                                                >
                                                    <DatePicker placeholder='WIL Period Start'
                                                            className="parts-numberInput datePickerAllWidth"
                                                            format={Config.dateFormatEn} disabled />
                                                </Form.Item>
                                            </div>
                                        </div>
                                        <div className='sysCol'>
                                            <div className="sysParam ">WIL Period End</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="periodEndDateIs"
                                                >
                                                    <DatePicker placeholder='WIL Period End'
                                                            className="parts-numberInput datePickerAllWidth"
                                                            format={Config.dateFormatEn} disabled />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='sysRow'>
                                        <div className='sysCol'>
                                            <div className="sysParam ">Company/ Organisation Name</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="companyNameIs"
                                                >
                                                    <Input type="text" placeholder='Company/ Organisation Name' disabled />
                                                </Form.Item>
                                            </div>
                                        </div>
                                        <div className='sysCol'>
                                            <div className="sysParam ">Company/ Organisation Address</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="companyAddressIs"
                                                >
                                                    <Input type="text" placeholder='Company/ Organisation Address' disabled />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='sysRow'>
                                        <div className='sysCol'>
                                            <div className="sysParam ">Name</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="industrySupervisorNameIs"
                                                >
                                                    <Input type="text" placeholder='Name' disabled />
                                                </Form.Item>
                                            </div>
                                        </div>
                                        <div className='sysCol'>
                                            <div className="sysParam ">Position</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="industrySupervisorPositionIs"
                                                >
                                                    <Input type="text" placeholder='Position' disabled />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='sysRow'>
                                        <div className='sysCol'>
                                            <div className="sysParam ">Telephone Number</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="industrySupervisorPhoneIs"
                                                >
                                                    <Input type="text" placeholder='Telephone Number' disabled />
                                                </Form.Item>
                                            </div>
                                        </div>
                                        <div className='sysCol'>
                                            <div className="sysParam ">Email Address</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="industrySupervisorEmailIs"
                                                >
                                                    <Input type="text" placeholder='Email Address' disabled />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='websiteSysRow title'>
                                    SECTION A - MAJOR WIL ACTIVITIES
                                </div>
                                <div className='websiteSysButtonRow'>
                                    <div className='detailStatusBox'>
                                        <div className='contentTitle2'>Activity</div>
                                    </div>
                                    <div className='websiteSysButtonBox'>
                                        <div className='contentTitle2' >% Proportion of Time Spent</div>
                                    </div>
                                </div>
                                <div className='websiteSysRow'>
                                    <div className='websiteSysCol'>
                                        <div className='label '>1</div>
                                        <div className="websiteSysInput">
                                            <Form.Item
                                                name="activity1"
                                            >
                                                <Input className="input" type="text"  maxLength={400} disabled />
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='websiteSysColMin'>
                                        <div className="websiteSysInput">
                                            <Form.Item
                                                name="activityProportion1"
                                            >
                                                <Input className="input" type="text" maxLength={8} precision={2} addonAfter={"%"} disabled />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='websiteSysRow'>
                                    <div className='websiteSysCol'>
                                        <div className='label '>2</div>
                                        <div className="websiteSysInput">
                                            <Form.Item
                                                name="activity2"
                                            >
                                                <Input className="input" type="text"  maxLength={400} disabled />
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='websiteSysColMin'>
                                        <div className="websiteSysInput">
                                            <Form.Item
                                                name="activityProportion2"
                                            >
                                                <Input className="input" type="text" maxLength={8} precision={2} addonAfter={"%"} disabled />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='websiteSysRow'>
                                    <div className='websiteSysCol'>
                                        <div className='label '>3</div>
                                        <div className="websiteSysInput">
                                            <Form.Item
                                                name="activity3"
                                            >
                                                <Input className="input" type="text"  maxLength={400} disabled />
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='websiteSysColMin'>
                                        <div className="websiteSysInput">
                                            <Form.Item
                                                name="activityProportion3"
                                            >
                                                <Input className="input" type="text" maxLength={8} precision={2} addonAfter={"%"} disabled />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='labelCircleBox marginTop20'>
                                    <div className='websiteSysRow title  '>
                                        SECTION B - ASSESSMENT OF STUDENT COMPETENCIES
                                    </div>
                                    <Popover placement="right" content={<div style={{ maxWidth: "500px", textAlign: 'justify' }}>
                                        {wpaQuestionModel?.IBoxContent}
                                    </div>} trigger="hover">
                                        <div className='labelCircle'><InfoCircleOutlined /></div>
                                    </Popover>
                                </div>
                                
                                <div className="sysTable" id="tableOne">
                                    <Table
                                        scroll={{ x: 500 }}
                                        rowKey="id"
                                        columns={columnsQustion} //列名
                                        dataSource={tablesQustion} //数据
                                        pagination={false}
                                    />
                                </div>
                                <div className='websiteSysRow title marginTop20'>
                                    SECTION C - WORK PERFORMANCE AND COMMENTS
                                </div>
                                <div className="checkbox">
                                    <Form.Item
                                        name="workPerformance"
                                    >
                                        <Radio.Group
                                            options={[
                                                {
                                                    label: 'Excellent (5)',
                                                    value: 5,
                                                },
                                                {
                                                    label: 'Good (4)',
                                                    value: 4,
                                                },
                                                {
                                                    label: 'Satisfactory (3)',
                                                    value: 3,
                                                },
                                                {
                                                    label: 'Acceptable (2)',
                                                    value: 2,
                                                },
                                                {
                                                    label: 'Unsatisfactory (1)',
                                                    value: 1,
                                                },
                                                {
                                                    label: 'Unacceptable (0)',
                                                    value: 0,
                                                },
                                            ]}
                                            disabled
                                        />
                                    </Form.Item>
                                </div>
                                <div className='websiteSysRow'>
                                    <div className='websiteSysCol'>
                                        <div className="sysParam">Areas of Strength</div>
                                        <div className="sysInputs">
                                            <Form.Item
                                                name="strengthArea"
                                            >
                                                <TextArea rows={3} placeholder="Areas of Strength" disabled />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='websiteSysRow'>
                                    <div className='websiteSysCol'>
                                        <div className="sysParam">Areas of Growth</div>
                                        <div className="sysInputs">
                                            <Form.Item
                                                name="growthArea"
                                            >
                                                <TextArea rows={3} placeholder="Areas of Growth" disabled />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='websiteSysRow'>
                                    <div className='websiteSysCol'>
                                        <div className="sysParam">Comments</div>
                                        <div className="sysInputs">
                                            <Form.Item
                                                name="workPerformanceComment"
                                            >
                                                <TextArea rows={3} placeholder="Comments" disabled />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam ">Name of Industry Supervisor</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="signature"
                                            >
                                                <Input type="text" placeholder='Name of Industry Supervisor' disabled />
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam ">Date</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="signatureDate"
                                            >
                                                <DatePicker placeholder='Date'
                                                        className="parts-numberInput datePickerAllWidth"
                                                        format={Config.dateFormatEn} disabled />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam ">Signature of Industry Supervisor with Company Stamp</div>
                                        <div className="sysInput">
                                            {wpaApplModel?.signatureImgPath && <img src={Config.wpaApplImg + wpaApplModel?.signatureImgPath + '?' + Config.sasToken} />}
                                        </div>
                                    </div>
                                </div>
                                {wpaApplModel?.filePath && <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam ">WPA Paper Form</div>
                                        <div className="sysInput">
                                            <div className="uploadFileRow" >
                                                <img src={tag1} className="tagImg"></img>
                                                <div onClick={() => downloadFile(wpaApplModel)} className='tableEllipsisBoxClamp1' >{wpaApplModel.fileName}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>}
                                <div className='websiteSysRow title'>
                                    Notes and Comments
                                </div>
                                <div className='websiteSysRow'>
                                    <div className='websiteSysCol'>
                                        <div className="sysParam">AS Private Remarks (Visible only to academic staff.)</div>
                                        <div className="sysInputs">
                                            <Form.Item
                                                name="remarks"
                                            >
                                                <TextArea rows={3} placeholder="AS Private Remarks (Visible only to academic staff.)" disabled />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='websiteSysRow'>
                                    <div className='websiteSysCol'>
                                        <div className="sysParam">AS Comments to Student (Optional. Unchangeable once Form is Accepted.)</div>
                                        <div className="sysInputs">
                                            <Form.Item
                                                name="comments"
                                            >
                                                <TextArea rows={3} placeholder="AS Comments to Student (Optional. Unchangeable once Form is Accepted.)" disabled />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className="sysSaveButton" >
                                    {(wpaApplModel?.wpaStatus == 'ACCEPTED' || wpaApplModel?.wpaStatus == 'ACCEPTED_OFFLINE') && <Button className="sysBtn btnBlue" type="primary" onClick={() => generatePdf()} hidden={Config.funcInfo.canDownload === "N"} icon={<DownloadOutlined />}>{trans.download[Config.backLang]}</Button>}
                                    <Button className="sysBtn" onClick={cancel} icon={<CloseCircleOutlined />}>{trans.cancel[Config.backLang]}</Button>
                                </div>
                            </Form>
                        </TabPane>
                    </Tabs>
                </Spin>
            </div>
            {isSearchModuleModal && <SelectCohortModule onClose={selectCohortModuleClose} />}
            {isSearchCohortProgModal && <CohortProgSearchModal onClose={closeSearchCohortProgModal} />}
        </div>
    )
}

export default WpaApplRecord;